// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1pY73","image":"Header_image__3ukp-","name":"Header_name__2btpI","info":"Header_info__1bCbA","infoRow":"Header_infoRow__L3oQc"};